import optionsApi from "../api/optionsApi";

interface PublicKeyCache {
  keyId: string;
  cryptoKey: CryptoKey;
}

let keyCache: PublicKeyCache | null = null;

async function fetchPiiPublicKey(): Promise<PublicKeyCache> {
  const res = await optionsApi.get("v1/employee/pii-public-key");
  const { publicKey, keyId } = res.data.data;

  if (keyCache?.keyId === keyId) return keyCache!;

  const pemBody = (publicKey as string)
    .replace(/-----[^-]+-----/g, "")
    .replace(/\s+/g, "");
  const binaryDer = Uint8Array.from(atob(pemBody), (c) => c.charCodeAt(0));

  const cryptoKey = await window.crypto.subtle.importKey(
    "spki",
    binaryDer.buffer,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );

  keyCache = { keyId, cryptoKey };
  return keyCache;
}

export async function encryptPii(value: string): Promise<string> {
  const { cryptoKey } = await fetchPiiPublicKey();
  const encoded = new TextEncoder().encode(value);
  const encrypted = await window.crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    cryptoKey,
    encoded
  );
  return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}

export function maskPii(value?: string | null): string {
  if (!value) return "";
  if (value.length <= 4) return "*".repeat(value.length);
  return "*".repeat(value.length - 4) + value.slice(-4);
}
